import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { DnSimpleTableComponent } from './dn-simple-table/dn-simple-table.component';

@NgModule({
  declarations: [DnSimpleTableComponent],
  imports: [CommonModule, MatTableModule],
  exports: [DnSimpleTableComponent],
})
export class DnTableModule {}
